import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SectionRenderer from "@/components/site/SectionRenderer";
import SEO from "@/components/site/SEO";
import NotFound from "@/pages/NotFound";
import { useLanguage } from "@/i18n/LanguageContext";
import { bi } from "@/lib/bilingual";

/**
 * Renders a system CMS page by route_key (home, about, services, ...).
 * Falls back to NotFound if missing; optional fallbackElement for gradual rollout.
 */
const CmsPage = ({ routeKey, fallback = null }) => {
  const [page, setPage] = useState(null);
  const { t, lang } = useLanguage();

  useEffect(() => {
    setPage(null);
    api
      .get(`/pages/public-by-route/${routeKey}`)
      .then(({ data }) => setPage(data))
      .catch(() => setPage(false));
    window.scrollTo(0, 0);
  }, [routeKey]);

  if (page === null) {
    return <div className="pt-40 text-center text-zinc-500">{t("common.loading")}</div>;
  }

  if (page === false) {
    if (fallback) return fallback;
    return <NotFound />;
  }

  const seoTitle = bi(page.seo_title, lang) || page.title;
  const seoDesc = bi(page.seo_description, lang);

  return (
    <div>
      <SEO title={seoTitle} description={seoDesc} />
      {(page.sections || []).map((s) => (
        <SectionRenderer key={s.id} section={s} />
      ))}
      {(page.sections || []).length === 0 && (
        <div className="pt-40 pb-20 text-center text-zinc-400">Belum ada konten. Edit di Admin → Pages.</div>
      )}
    </div>
  );
};

export default CmsPage;
